<template>
  <FlatActionButton
    v-if="!item.provider"
    :action="() => handleClick(item)"
    :class="$style.detailsButton"
  >
    {{ buttonText }}
  </FlatActionButton>
</template>

<script>

import FlatActionButton from 'client/components/Buttons/FlatActionButton.vue';

export default {
  name: 'AdminDetailButton',

  components: {
    FlatActionButton,
  },

  props: {
    buttonText: {
      type: String,
      required: true,
    },
    handleClick: {
      type: Function,
      required: true,
    },
    item: {
      type: Object,
      required: true,
    },
  },
};
</script>
<style scoped module>
.detailsButton {
  margin-right: 15px;
}
</style>
